export * from './lib/svg-processor.service.module';

export { AccredibleSvgProcessorService } from './lib/svg-processor.service';
